/**
 * Auto-generated from dark-roast/api-envoy OpenAPI spec. Do not edit manually.
 * Regenerate with: yarn sync-entities
 */

export enum ReputationDetailsStatus {
  Processed = "Processed",
  Dismissed = "Dismissed",
  Shared = "Shared",
  SharedLive = "SharedLive",
  AutoSending = "AutoSending",
  Coaching = "Coaching",
  Disputed = "Disputed",
  LowScore = "LowScore",
  New = "New",
}

export const ReputationDetailsStatusDisplay: Record<ReputationDetailsStatus, string> = {
  [ReputationDetailsStatus.Processed]: "Processed",
  [ReputationDetailsStatus.Dismissed]: "Dismissed",
  [ReputationDetailsStatus.Shared]: "Shared",
  [ReputationDetailsStatus.SharedLive]: "Shared Live",
  [ReputationDetailsStatus.AutoSending]: "Auto Sending",
  [ReputationDetailsStatus.Coaching]: "Coaching",
  [ReputationDetailsStatus.Disputed]: "Disputed",
  [ReputationDetailsStatus.LowScore]: "Low Score",
  [ReputationDetailsStatus.New]: "New",
};
